<template>
    <div class="hidden lg:flex w-full lg:w-1/2 relative items-center justify-center overflow-hidden bg-[#0f1035]">
        <!-- Background Image -->
        <img src="/media/registerTenant/bgStep.png" alt="Background" class="absolute inset-0 w-full h-full object-cover z-0" />

        <!-- Content Overlay -->
        <div
            class="relative z-10 w-full max-w-md px-10 flex flex-col items-baseline text-center lg:text-left"
            style="height: 70%"
        >
            <!-- Logo area if needed, based on screenshot it's top left but we center content for now or match design -->
            <div class="w-full mb-8">
                <img src="/media/svg/logoPlayProWithoutName.svg" alt="Logo" class="h-12" />
            </div>

            <h2 class="text-white mb-6 leading-tight w-full poppinsMedium" :style="{ fontSize: normalizeFontSize(32) }">
                {{ title !== null ? title : 'Welcome to PlayPro' }}
            </h2>

            <p class="text-white mb-8 leading-relaxed poppinsMedium" :style="{ width: '70%', fontSize: normalizeFontSize(16) }">
                {{ text !== null ? text : 'Play your next level — join PlayPro and start creating amazing experiences.' }}
            </p>

            <p class="text-white w-full mb-8 poppinsMedium" :style="{ fontSize: normalizeFontSize(16) }">
                {{ bottomText !== null ? bottomText : 'No credit card required to get started.' }}
            </p>
        </div>

        <!-- Device Mockup Image -->
        <img
            :src="image"
            class="absolute right-[40px] bottom-0 object-contain transform translate-x-10 max-w-[750px] w-full"
            alt="App Preview"
        />
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'
import normalizeFontSize from '../../../utils/normalizeFontSize'

export default {
    name: 'bg2Step',
    props: {
        title: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        bottomText: {
            type: String,
            default: null,
        },
        image: {
            type: String,
            default: '/media/registerTenant/bg2Step.png',
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
}
</script>

<style scoped>
/* Add any specific styles here if needed */
</style>
